export default {"src":"/_next/static/media/maaran_main_logo_black.4d4a3a3b.svg","height":781,"width":3685,"blurWidth":0,"blurHeight":0};